export const items10 = Array.from(Array(10).keys());
export const items8 = Array.from(Array(8).keys());
export const items6 = Array.from(Array(6).keys());
export const items5 = Array.from(Array(5).keys());
export const items4 = Array.from(Array(4).keys());
export const items3 = Array.from(Array(3).keys());
export const items2 = Array.from(Array(2).keys());

export const taxonomies = [
  {
    name: 'Styles',
    open: false,
    terms: [
      { name: 'Hatha', important: true, selected: false },
      { name: 'Yin yoga', important: true, selected: false },
      { name: 'Partner yoga', selected: false },
      { name: 'Student yoga', selected: false },
      { name: 'Yoyo yoga', selected: false },
      { name: 'Something yoga', selected: false },
      { name: 'Bla yoga', selected: false },
      { name: 'Work yoga', selected: false },
      { name: 'Royce yoga', selected: false },
      { name: 'Marshall yoga', selected: false },
      { name: 'Twitter yoga', selected: false },
      { name: 'Fb yoga', selected: false },
      { name: 'Ko yoga', selected: false },
      { name: 'Lo yoga', selected: false },
      { name: 'Po yoga', selected: false },
      { name: 'Yaou yoga', selected: false },
    ],
  },
  {
    name: 'Duration',
    open: false,
    terms: [
      { name: '5 minutes', selected: false },
      { name: '15 minutes', selected: false },
    ],
  },
  {
    name: 'Something',
    open: false,
    terms: [{ name: 'Test', selected: false }],
  },
  {
    name: 'Something 2',
    open: false,
    terms: [{ name: 'Test again', selected: false }],
  },
  {
    name: 'Something 3',
    open: false,
    terms: [{ name: 'Test again again', selected: false }],
  },
];

export const CollectionCardMeta = {
  name: 'For athletes',
  thumbnailUrl: 'http://via.placeholder.com/300x295',
};

export const CourseCardMeta = {
  title: 'Fall asleep - Yoga Nidra',
  secondTitle: 'YOMI Yin online',
  description:
    'Kom ner i varv och hjälp kroppen att somna gott. de förberedande positionerna hjälper dig komma ner i varv och hitta in i kroppen innan du guidas in i yoga nidra, yogisk sömn, för total avslappning',
  thumbnailUrl: 'http://via.placeholder.com/500x500',
};

export const PlaylistCardMeta = {
  title: 'Fall asleep - Yoga Nidra',
  description:
    'Kom ner i varv och hjälp kroppen att somna gott. de förberedande positionerna hjälper dig komma ner i varv och hitta in i kroppen innan du guidas in i yoga nidra, yogisk sömn, för total avslappning',
  thumbnailUrl: 'http://via.placeholder.com/500x500',
  duration: 30,
  videoCount: 2,
  createdBy: 'Yogobe',
};

export const VideoCardMeta = {
  title: 'Yogalärartips: Passning i hunden för nybörjare',
  description:
    'Ett bra ställe att börja hela om vi kommit ur balans är hur viförhåller oss till oss själva',
  duration: 5,
  favorite: false,
  instructorName: 'Johanna Alvin',
  genre: 'Yin',
  thumbnailUrl: 'http://via.placeholder.com/500x500',
  videoSlug: '/test1',
  instructorSlug: '/instructor1',
  genreSlug: '/genre1',
};

export const BlogItemCardMeta = {
  title: '12 veckor till milen',
  description:
    'Kom igång med din löpträning! Magnus Hagström guidar dig mot målet att kunna springa 1 mil om 12 veckor. Ett program för alla som vill bygga upp en hållbar löpträning!',
  thumbnailUrl: 'http://via.placeholder.com/500x500',
  blogUrl: '',
};

export const RelatedVideoMeta = {
  name: 'Teknik asana: Eka Pada Galavasana / Fly lol hi something else?',
  description: 'Teknik för armbalans som stärker armar, axlar & core',
  thumbnailUrl: 'http://via.placeholder.com/500x500',
  videoUrl: '/test',
  duration: 5,
};

export const InstructorMeta = {
  firstName: 'Johanna',
  lastName: 'Alvin',
  description:
    'Johanna är i grunden idrottslärare och har de flesta instruktörsutbildningar inom gymvärlden i ryggen. Numera jobbar hon dock med yoga på heltid. Hon driver studion FLOW i Göteborg, jobbar med PT-kunder, håller workshops, kurser ...',
  thumbnailUrl: 'http://via.placeholder.com/60x60',
  instructorUrl: '/test',
};

export const ResultArticleMeta = {
  thumbnailUrl: 'http://via.placeholder.com/300x295',
  title: 'Ärtpesto – familjens nya middagsfavorit',
};

export const ResultUserMeta = {
  thumbnailUrl: 'http://via.placeholder.com/300x295',
  name: 'Dianne Ameter',
};

export const ResultPositionMeta = {
  thumbnailUrl: 'http://via.placeholder.com/300x295',
  title: 'Title',
  english_title: 'English title',
  local_language_title: 'local_language_title',
};
